var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import ClaimsButton from '@declaration/components/UI/ClaimsButton.vue';
import BreakInDamageChoices from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageChoices.vue';
import { LITTLE_GATE_HEIGHT_TRAD_KEYS_AND_IMAGES } from '@shared/constants/breakInDamages/LittleGateConstants';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let LittleGateHeight = class LittleGateHeight extends Vue {
    constructor() {
        super(...arguments);
        this.isSaving = false;
        this.showValidation = false;
        this.littleGateHeights = Object.entries(LITTLE_GATE_HEIGHT_TRAD_KEYS_AND_IMAGES).map(([height, description]) => description
            ? {
                value: height,
                tradKey: description.tradKey,
                descriptionTradKey: description.descriptionTradKey,
                image: description.image,
            }
            : null);
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get isValid() {
        return !this.validation.fieldHasViolations('littleGateHeight');
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.isSaving = true;
        this.$emit('goToNextStep');
        this.isSaving = false;
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
};
__decorate([
    layout.State('color')
], LittleGateHeight.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], LittleGateHeight.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], LittleGateHeight.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], LittleGateHeight.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], LittleGateHeight.prototype, "validateBreakInDamage", void 0);
LittleGateHeight = __decorate([
    Component({
        components: {
            BreakInDamageDescriptionStep,
            BreakInDamageDescriptionSectionCard,
            BreakInDamageChoices,
            ClaimsButton,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
        },
    })
], LittleGateHeight);
export default LittleGateHeight;
